// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextField_field__Xqz50 {
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #272A36;
  padding: 12px 12px 12px 2px;
  resize: none;
  border: 0;
  outline: none;
  -webkit-tap-highlight-color: #8E8E93;
  overflow: -moz-scrollbars-none;
  overflow: -moz-hidden-unscrollable;
  scrollbar-width: none;
}
.TextField_field__Xqz50::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #8E8E93;
  opacity: 1; /* Firefox */
}
.TextField_field__Xqz50:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #8E8E93;
}
.TextField_field__Xqz50::-ms-input-placeholder { /* Microsoft Edge */
  color: #8E8E93;
}
.TextField_field__Xqz50:focus, .TextField_field__Xqz50:active {
  outline: none;
}
.TextField_field__Xqz50::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  -ms-overflow-style: none;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatBottomPanels/NewMessagePanel/TextField/TextField.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAIA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAEA,2BAAA;EAEA,YAAA;EACA,SAAA;EACA,aAAA;EAEA,oCAdkB;ECKlB,8BAAA;EACA,kCAAA;EACA,qBAAA;ADIF;AAKE,uCAAA,yCAAA;EACE,cAjBgB;EAkBhB,UAAA,EAAA,YAAA;AAHJ;AAME,gDAAA,4BAAA;EACE,cAtBgB;AAkBpB;AAOE,iDAAA,mBAAA;EACE,cA1BgB;AAqBpB;AAQE;EACE,aAAA;AANJ;ACfE;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;ADiBJ","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n$placeholder-color: #8E8E93;\n\n.field {\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n  color: #272A36;\n\n  padding: 12px 12px 12px 2px;\n\n  resize: none;\n  border: 0;\n  outline: none;\n\n  -webkit-tap-highlight-color: $placeholder-color;\n\n  &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: $placeholder-color;\n    opacity: 1; /* Firefox */\n  }\n\n  &:-ms-input-placeholder { /* Internet Explorer 10-11 */\n    color: $placeholder-color;\n  }\n\n  &::-ms-input-placeholder { /* Microsoft Edge */\n    color: $placeholder-color;\n  }\n\n  &:focus, &:active {\n    outline: none;\n  }\n\n  @include invisible-scroll;\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `TextField_field__Xqz50`
};
export default ___CSS_LOADER_EXPORT___;
